/**
 * HOME-ROUTE
 * IDTREE home page
 */
import NavApp from "@/nav/nav.app"
import HomeSurveysWidget from "@/widgets/home-surveys.widget"
import Space from "@/components/space"
import SurveyHomeWidget from "@/features/survey/widgets/survey-home.widget"
import { t } from "i18next"
import { useState } from "react"
import SetPasswordModal from "@/modals/set-password.modal"
import { useAppSelector } from "@/core/root-reducer"
import HomeActionsPlanWidget from "@/widgets/home-actions-plan.widget"

function HomeAccountRoute() {
  const _session = useAppSelector((state) => state._session)

  //State
  const [modal, setModal] = useState<"MODAL_SET_PASSWORD" | null>(null)

  const HomeView =
    _session.userRole === "ADMIN" ? (
      <SurveyHomeWidget />
    ) : (
      <div className="flex">
        <Space />
        <div>
          {_session.modules.survey.task && <HomeActionsPlanWidget />}
          <HomeSurveysWidget />
        </div>
        <Space />
      </div>
    )

  const showPasswordWarning =
    !_session.userPasswordProvided &&
    _session.supervisorLevel === 0 &&
    _session.connexionMode !== "GOOGLE" &&
    !_session.accountOptions.sso

  return (
    <NavApp>
      {modal === "MODAL_SET_PASSWORD" && <SetPasswordModal onClose={() => setModal(null)} passwordMinLength={8} />}

      {HomeView}

      {showPasswordWarning && (
        <div className="flex page-navigation-footer">
          <div style={{ margin: "auto" }}>
            {t("self_password_empty")}&nbsp;
            <span onClick={() => setModal("MODAL_SET_PASSWORD")}>{t("self_password_create")}</span>
          </div>
        </div>
      )}
    </NavApp>
  )
}

export default HomeAccountRoute
